import create from 'zustand';
import { VirtualPortfolio, VirtualPortfolioList } from '../types/api/portfolio';
import { getPortfolioDetail, getPortfolioList } from '../api/portfolio';

interface State {
  portfolio: Partial<VirtualPortfolio>;
  portfolioList: VirtualPortfolioList;
}

interface Actions {
  loadPortfolioDetail(symbol: string): Promise<void>;
  loadPortfolioList(): Promise<void>;
}

const initialState: State = {
  portfolio: {
    available_lot: 0,
    balance_lot: 0,
    price: {
      order: 0,
      average: 0,
      market: 0,
    },
  },

  portfolioList: {
    trading_balance: 0,
    amount: {
      invested: 0,
      allocated: 0,
      credit_limit: 0,
    },
    result: [],
    profit_loss: {
      unrealized: 0,
      realized: 0,
      total: 0,
    },
    equity: 0,
    gain: 0,
  },
};

export const usePortfolioStore = create<State & Actions>((set) => ({
  ...initialState,
  async loadPortfolioDetail(symbol) {
    try {
      const { data: axiosData } = await getPortfolioDetail(symbol);
      const { data } = axiosData;

      set({ portfolio: data });
    } catch (e) {
      Promise.reject(e);
    }
  },

  async loadPortfolioList() {
    try {
      const { data: axiosData } = await getPortfolioList();
      const { data } = axiosData;
      set({ portfolioList: data });
    } catch (e) {
      Promise.reject(e);
    }
  },
}));

export default usePortfolioStore;
